import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { ArrowUpRight, BookOpen } from "lucide-react";
import { IMAGES } from "../data/content";
import { ARTICLES } from "../data/articles";

export default function Ratgeber() {
  return (
    <>
      <Seo title="Ratgeber & Energiewissen" description="Fundierte Artikel rund um Strom, Gas, Photovoltaik und Wärmepumpe – verständlich erklärt vom unabhängigen Energie-Tarifberater." path="/ratgeber" />
      <PageHero
        eyebrow="Ratgeber"
        titleLines={["Energiewissen,", 'klar <span class="font-serif italic text-blue-700">erklärt.</span>']}
        subtitle="Fundierte Artikel rund um Strom, Gas, Photovoltaik und Wärmepumpe – ohne Fachchinesisch."
        breadcrumb={[{ label: "Ratgeber" }]}
      />

      <section className="bg-background py-24 sm:py-32">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {ARTICLES.map((a, i) => (
              <Reveal key={a.slug} delay={(i % 3) * 0.08}>
                <Link to={`/ratgeber/${a.slug}`} className="group rounded-3xl overflow-hidden border border-slate-200 bg-white hover:-translate-y-1.5 hover:shadow-[0_40px_80px_-45px_rgba(0,0,0,0.25)] transition-[transform,box-shadow] duration-500 h-full flex flex-col" data-testid={`article-${a.slug}`}>
                  <div className="relative h-52 overflow-hidden">
                    <img src={IMAGES[a.img]} alt={a.title} loading="lazy" className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-1000" />
                    <span className="absolute top-4 left-4 rounded-full bg-navy-950/80 backdrop-blur-md text-white text-xs px-3 py-1.5">{a.cat}</span>
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <div className="flex items-center gap-2 text-xs text-slate-400 mb-3">
                      <BookOpen className="h-3.5 w-3.5" /> {a.read} Lesezeit
                    </div>
                    <h3 className="text-xl font-heading text-navy-900 leading-snug mb-3 group-hover:text-blue-700 transition-colors">{a.title}</h3>
                    <p className="text-slate-500 text-sm leading-relaxed flex-1">{a.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-blue-700">
                      Artikel lesen <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="mt-16 rounded-3xl bg-blue-700 p-12 text-center">
              <h3 className="text-3xl font-heading font-semibold text-white mb-4">
                Lieber direkt <span className="font-serif italic text-blue-200">Klarheit?</span>
              </h3>
              <p className="text-slate-300 max-w-xl mx-auto mb-8">Statt lange zu lesen: Laden Sie Ihre Rechnung hoch und erhalten Sie eine persönliche Einschätzung in 24 Stunden.</p>
              <Link to="/kontakt" className="inline-flex rounded-full bg-white hover:bg-blue-50 text-blue-700 px-8 py-4 font-medium transition-colors" data-testid="ratgeber-cta">
                Jetzt beraten lassen
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
